import { collectModuleExtensionExports } from '../utils/moduleExtensions';
import { sheetContentWidgetFactories as omniaSheetContentWidgetFactories } from '../themes/Omnia/utils/sheetContentWidget';

// Multi-tenant development discovers all installed extensions. Tenant builds
// replace these exports with the explicitly selected contributions.
export const vueformExtensionElements = collectModuleExtensionExports(
    import.meta.glob('../modules/*/vueformElements.js', { eager: true }),
    'vueformExtensionElements',
);
export const sheetContentWidgetFactories = [
    ...collectModuleExtensionExports(
        import.meta.glob('../modules/*/sheetContentWidget.js', { eager: true }),
        'sheetContentWidgetFactories',
    ),
    // Theme sheet-body adapters: the Omnia media viewers (3D model, panorama).
    ...omniaSheetContentWidgetFactories,
];
export const schemaFieldExtensionHandlers = collectModuleExtensionExports(
    import.meta.glob('../modules/*/schemaFieldExtension.js', { eager: true }),
    'schemaFieldExtensionHandlers',
);
export const newSchedaExtensionFactories = collectModuleExtensionExports(
    import.meta.glob('../modules/*/newSchedaExtension.js', { eager: true }),
    'newSchedaExtensionFactories',
);
